<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="90">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="客户" prop="customerId">
                        <Select v-model="info.customerId" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in customerInfoList"
                                :value="item.id"
                                :key="index">
                                {{item.customerName}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="姓名" prop="nickname">
                        <Input v-model="info.nickname" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机号" prop="phone">
                        <Input v-model="info.phone" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="性别" prop="gender">
                        <Select v-model="info.gender" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in genderList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="汇报对象" prop="reportUserId">
                        <form-lookup v-model="info.reportUserId"
                            :readonly="readonly"
                            placeholder
                            title="选择汇报对象"
                            textSymbol="nickname"
                            :modalHeight="540"
                            :modalWidth="800"
                            :options.sync="empOptions">
                            <select-outside multiple></select-outside>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="部门" prop="dept">
                        <Input v-model="info.dept" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="岗位" prop="position">
                        <Input v-model="info.position" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="说明" prop="remark">
                        <Input type="textarea" v-model="info.remark"
                            :readonly="readonly"
                            placeholder :rows="3" :maxlength="1000">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { tel } from '_u/validate'
import SelectOutside from '_vc/select-outside'
import { 
    customerList, 
    customerUserView, 
    customerUserAdd, 
    customerUserUpdate 
} from '@/api/customer-manage'
import Enum from '_u/enum'

export default {
    name: 'FormCustomer',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {
        SelectOutside
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                customerId: '',     // 客户
                nickname: '',       // 姓名
                phone: '',          // 手机号
                gender: '',         // 性别
                reportUserId: '',   // 汇报对象
                dept: '',           // 部门
                position: '',       // 岗位
                remark: '',         // 说明
                ver: ''             // 版本号
            },
            customerInfoList: [],
            gender: Enum.get('sex'),
            empOptions: []
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can('update') : this.$can('add')
        },

        readonly() {
            return !this.canSave
        },
        
        ruleValidate() {
            return {
                customerId: [
                    { 
                        required: true, 
                        message: '客户必填' 
                    }
                ],
                nickname: [
                    { 
                        required: true, 
                        message: '姓名必填' 
                    }
                ],
                phone: [
                    { 
                        required: true, 
                        message: '手机号必填' 
                    },
                    { 
                        validator: tel 
                    }
                ]
            }
        },
        genderList() {
            return this.gender.toList()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return customerUserView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([customerList({pageNo:1, pageSize: 999}), this.fetch()])
                .then(args => {
                    var [customer, view] = args
                    if (customer) {
                        this.customerInfoList = customer.data.page.list
                    }
                    if (view) {
                        var viewData = view.data
                        if (!viewData.reportUserId || viewData.reportUserId == 0) {
                            viewData.reportUserId = ""
                            viewData.reportUserName = ""
                        }
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                        let ids = viewData.reportUserId.split(',') || [],
                            names = viewData.reportUserName.split(',') || []
                        for (let i = 0; i < ids.length; i++) {
                            this.empOptions.push({
                                id: ids[i],
                                nickname: names[i]
                            })
                        }
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                 
                    if (this.id) {
                        return customerUserUpdate(formData)
                    } else {
                        return customerUserAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
